import React from 'react';
import Image from 'gatsby-plugin-sanity-image';

import { BlockWrapper } from '../blockWrapper';
import { PortableTextBlock } from '@modules/portableTextBlock';

const Sponsors = ({ blockConfig, imageSponsors, imageTexts }) => {
  return (
    <BlockWrapper
      className={`grid grid-cols-14 gap-y-14 lg:gap-y-32 text-center`}
      {...blockConfig}>
      {imageSponsors?.map((sponsor, i) => {
        return (
          <div key={i} className='col-start-2 col-end-14'>
            <h3 className='text-2xl leading-2xl md:text-4xl md:leading-4xl font-medium col-start-2 col-end-14 pb-5 lg:pb-12 mb-5 lg:mb-12 border-b border-grey'>
              {sponsor.heading}
            </h3>
            <div className='grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12'>
              {sponsor?.images?.map((img, i) => {
                return (
                  <div key={i}>
                    {img?.title && (
                      <p className='mb-2 text-xs leading-xs md:text-base md:leading-base'>
                        {img?.title}
                      </p>
                    )}
                    <a href={img?.altTag} target='_blank' rel='noreferrer'>
                      {img?.figureImage && (
                        <Image
                          className='md:h-20 mx-auto w-auto'
                          {...img.figureImage}
                        />
                      )}
                    </a>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}

      {imageTexts.map((sponsor, i) => {
        return (
          <div key={i} className='col-start-2 col-end-14'>
            <h3 className='text-2xl md:text-4xl text-2xl md:leading-4xl font-medium col-start-2 col-end-14 pb-5 mb-5 lg:pb-12 lg:mb-12 border-b border-grey'>
              {sponsor.heading}
            </h3>
            <div className='grid grid-cols-2 gap-y-6 lg:gap-y-12 gap-x-8 prose md:prose-lg text-black'>
              {sponsor.text.map((text, i) => {
                return (
                  <div key={i} className='text-sponsors'>
                    {text.heading && (
                      <h3 className='mb-2 font-medium'>{text.heading}</h3>
                    )}
                    <PortableTextBlock text={text.text} />
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </BlockWrapper>
  );
};

export default Sponsors;
